import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class CustomDateRange extends React.Component {

  static contextTypes = {
    modal: PropTypes.object
  }

  static propTypes = {
    start: PropTypes.string,
    end: PropTypes.string,
    onCancel: PropTypes.func,
    onDone: PropTypes.func
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { start, end } = this.props
    return {
      title: 't(Custom Date Range)',
      onCancel: this._handleCancel,
      onSubmit: this._handleSubmit,
      onSuccess: this._handleSuccess,
      saveText: 't(Apply)',
      sections: [
        {
          fields: [
            { label: 't(Start Date)', name: 'start', type: 'datefield', required: true, defaultValue: start },
            { label: 't(End Date)', name: 'end', type: 'datefield', required: true, defaultValue: end }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.props.onCancel()
    this.context.modal.close()
  }

  _handleSubmit(data) {
    return data
  }

  _handleSuccess(data) {
    this.props.onDone(data)
    this.context.modal.close()
  }

}

export default CustomDateRange
